(function ($) {
    const mfSetUrl = (baseurl = window.location.href) => {
        if (baseurl.includes("executefilter")) return;

        let querydata = {};
        $('.mf_filter').each(function () {
            const $this = $(this);
            const name = $this.attr('name');
            const value = $this.val();
            const type = $this.attr('type');

            if ((type === 'checkbox' && $this.prop('checked')) || (type !== 'checkbox' && value)) {
                querydata[name] = value;
            }
        });

        if (!$.isEmptyObject(querydata)) {
            querydata.fnc = 'executefilter';
            const url = new URL(baseurl, window.location.origin);
            Object.keys(querydata).forEach(key => url.searchParams.set(key, querydata[key]));
            history.replaceState({}, '', url);
        }
    };

    const afterAjax = (baseurl) => {
        $('#filterList').ajaxForm({
            dataType: 'json',
            beforeSerialize: showRequest,
            success: processJson,
            error: (xhr, status, error) => console.error('AJAX error:', status, error, xhr.responseText)
        });
        mfSetUrl(baseurl);
    };

    function showRequest(formData, jqForm, options) {
        $('input[name=ajax]').val('1');
        $('input[name=mnid]').val('');
        $("#mfmask").show();
        return true;
    }

    // Loader folgt der Maus (globaler Listener)

    document.addEventListener("mousemove", function (e) {
        const loader = document.getElementById("mfloader");
        if (!loader) return;

        loader.style.left = 30 + e.clientX + "px";
        loader.style.top =  -10 + e.clientY + "px";
    });
    function processJson(data) {
        Object.keys(data).forEach(index => {
            if (index !== "baseurl") {
                $('#' + index).html(data[index]);
            }
        });
        $("#mfmask").hide();
        afterAjax(data.baseurl);
        initAccordion();
    }

    $("#multifilter_filters, #wrapper").on("click", ".multifilter_reset_icon, .multifilter_reset_link", function (e) {
        e.preventDefault();
        $('#multifilter_reset').val($(this).data('ident'));
        $('#filterList').submit();
    });

    $("#multifilter_filters").on("click", ".colorpickerjs", function (e) {
        e.preventDefault();

        const $swatch = $(e.target).closest('.colorpick');      // immer der gesamte Swatch
        const $input  = $swatch.find('.mf_filter').first();     // Hidden-Input sicher finden

        $input.val($input.val() ? '' : '1');
        $("#filterList").submit();
    });

    $("#multifilter_filters").on("click", ".attrfilter a", () => $("#mfmask").show());
    $('.searchBox').append('<input type="hidden" name="resetfilter" value="1" />');
    afterAjax();

})(jQuery);
